"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WorkflowContext = require("./WorkflowContext");

var WorkflowConsumer = function WorkflowConsumer(props) {
  return /*#__PURE__*/(0, _jsx2.default)(_WorkflowContext.WorkflowContext.Consumer, {}, void 0, function (context) {
    if (!context) {
      throw new Error('Workflow compound components must be rendered within the Workflow component tree.');
    }

    return props.children(context);
  });
};

var _default = WorkflowConsumer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowConsumer.js
// module id = 442
// module chunks = 25